import ApiConstants from "../../Constants/ApiConstant";
import { apiPost, apiPut } from "../../Services/ApiService";

export const loginUserAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.loginUserUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("add product details api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("add product details api err:", err);
      throw err;
    }
  };
};

export const registerUserAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.createUserUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("add product details api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("add product details api err:", err);
      throw err;
    }
  };
};

export const verifyUserOtpAPI = (data, callBack) => {
  return async (dispatch) => {
    try {
      await apiPut(ApiConstants.otpVerificationUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("API error:", err);
          throw err;
        });

      // const response = await apiPut(ApiConstants.otpVerificationUrl, data);

      // callBack && callBack(response?.data, response?.data);
    } catch (err) {
      console.log("API error:", err);
      throw err;
      // console.log("API error:", err);
      // callBack && callBack(null, { error: { message: err.message } });
    }
  };
};

export const resendUserOtpAPI = (data, callBack) => {
  return async (dispatch) => {
    try {
      await apiPost(ApiConstants.otpVerificationUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("resend api error:", err);
          throw err;
        });
    } catch (err) {
      console.log("resend api error:", err);
      throw err;
    }
  };
};
